import React, { useEffect, useState } from 'react';
import { Dropdown, Image, OverlayTrigger, Popover } from 'react-bootstrap';
import { PieChart, Settings, User, HelpCircle, FileText, Sliders, Tool, LogOut, LogOutCircle, LogOutSquare } from 'react-feather';
import { useNavigate, useLocation } from 'react-router-dom';
import useAuth from '../../hooks/useAuth';
import { useDispatch, useSelector } from 'react-redux'; // Import useSelector
import { fetchUploadedDocument } from '../../redux/slices/UploadDocumentSlice';
import RobotHead from '../../assets/img/joyride-head.png';
import { deleteTourProgress } from '../../redux/slices/TourProgressSlice';
import { getInitials } from '../../constants';
import useMutationObserver from './MutationObserver';

const NavbarUser = ({ showNav }) => {
  const { signOut } = useAuth();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const handleSignoutClick = () => {
    signOut();
    navigate('/');
  };
  let username = localStorage.getItem('username');
  const isAdmin = localStorage.getItem('isAdmin');
  const [isJoyrideActive, setIsJoyrideActive] = useState(false);
  const joyrideElement = useMutationObserver('.react-joyride');

  useEffect(() => {
    const checkJoyrideElement = () => {
      const joyrideElement = document.querySelector('.react-joyride');
      setIsJoyrideActive(!!joyrideElement);
    };

    // Run the check when the component mounts
    checkJoyrideElement();

    // Run the check whenever the location changes
    return () => {
      checkJoyrideElement();
    };
  }, [location]);

  // Access profile path from Redux state
  const userCurrentInfo = useSelector(state => state.uploadDocument.uploadDocumentData);
  const uploadDocumentStatus = useSelector(state => state.uploadDocument.status);
  const profilePath = userCurrentInfo?.response?.profile_img || '';
  const basePath = document.body.dataset['app_base_url'];
  const fullProfileImgUrl = profilePath ? (profilePath?.includes('https://') ? profilePath : basePath + profilePath) : null;
  const avatarUrl = fullProfileImgUrl; // Replace the avatarUrl with fullProfileImgUrl

  useEffect(() => {
    if (uploadDocumentStatus === 'idle') {
      dispatch(fetchUploadedDocument());
    }
  }, [uploadDocumentStatus, dispatch]);

  const popover = (
    <Popover id='robot-head-popover'>
      <Popover.Body className='text-center'>
        <p>Need a reminder on how this page works? </p>
        <p>
          I understand! Not everyone has a steel-trap memory like me... GENTLY, click on my <Image src={RobotHead} width={20} /> to get help!
        </p>{' '}
      </Popover.Body>
    </Popover>
  );

  return (
    <Dropdown className='nav-item' align='end'>
      <span className='d-inline-block d-sm-none'>
        <Dropdown.Toggle as='a' className='nav-link caret-off'>
          <Settings size={18} className='align-middle' />
        </Dropdown.Toggle>
      </span>
      <span className={`d-none d-sm-inline-block ${!joyrideElement && 'invisible'}`}>
        <Dropdown.Toggle onClick={() => dispatch(deleteTourProgress({ tour_name: location.pathname.replace('/', '') }))} as='a' className='nav-link caret-off'>
          <OverlayTrigger trigger={['hover', 'focus']} placement='bottom' overlay={popover}>
            <Image src={RobotHead} width={20} />
          </OverlayTrigger>
        </Dropdown.Toggle>
      </span>

      <span className='d-none d-sm-inline-block'>
        <Dropdown.Toggle as='a' className='nav-link caret-off'>
          {avatarUrl ? (
            <img src={avatarUrl} className='avatar img-fluid rounded-circle me-1' style={{ width: '30px', height: '30px' }} alt={getInitials(username ? username : 'User')} />
          ) : (
            <span
              className='avatar-initials img-fluid rounded-circle me-1 border border-2 border-primary text-primary bg-white'
              style={{
                width: '40px',
                height: '40px',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                fontSize: '16px',
                fontWeight: 'normal',
              }}>
              {getInitials(username ? username : 'User')}
            </span>
          )}
        </Dropdown.Toggle>
      </span>
      <Dropdown.Menu drop='end'>
        {/* <Dropdown.Item>
          <User size={18} className="align-middle me-2" />
          Profile
        </Dropdown.Item>
        <Dropdown.Item>
          <PieChart size={18} className="align-middle me-2" />
          Analytics
        </Dropdown.Item>
        <Dropdown.Divider />*/}
        {showNav && (
          <>
            <Dropdown.Item onClick={() => navigate('/help')}>
              <HelpCircle size={16} className='me-2' />
              Help
            </Dropdown.Item>
            <Dropdown.Item onClick={() => navigate('/documents')}>
              <FileText size={16} className='me-2' />
              Documents
            </Dropdown.Item>
            <Dropdown.Item onClick={() => navigate('/setting')}>
              <Sliders size={16} className='me-2' /> Settings
            </Dropdown.Item>
          </>
        )}

        {/*<Dropdown.Item>Help</Dropdown.Item> */}
        <Dropdown.Item onClick={() => handleSignoutClick()}>
          {' '}
          <span className='me-1'>👋</span> Sign out
        </Dropdown.Item>
      </Dropdown.Menu>
    </Dropdown>
  );
};

export default NavbarUser;
